import React, { useState, useEffect } from "react";
import waterproofing5 from "../assets/waterproofingvdo.mp4";
import { Droplets, ShieldCheck } from "lucide-react";
import BookConsultModal from "../pages/BookConsultModal";

// CHANGE: Interface add kiya gaya taaki prop accept ho sake
interface HeroSectionProps {
  setIsConsultOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const HeroSection: React.FC<HeroSectionProps> = ({ setIsConsultOpen: parentSetIsConsultOpen }) => {
  // Rename local state to avoid confusion
  const [localIsConsultOpen, setLocalIsConsultOpen] = useState(false);
  const [autoPopupTriggered, setAutoPopupTriggered] = useState(false);

  // Helper to open modal (Prioritize Parent if available)
  const openModal = () => {
    if (parentSetIsConsultOpen) {
      parentSetIsConsultOpen(true);
    } else {
      setLocalIsConsultOpen(true);
    }
  };

  useEffect(() => {
    const timer1 = setTimeout(() => {
      openModal();
      setAutoPopupTriggered(true);
    }, 2000);

    return () => clearTimeout(timer1);
  }, []);

  const handleClose = () => {
    if (parentSetIsConsultOpen) {
        parentSetIsConsultOpen(false);
    } else {
        setLocalIsConsultOpen(false);
    }
    
    if (!autoPopupTriggered) {
      setAutoPopupTriggered(true);
      setTimeout(() => openModal(), 10000);
    }
  };

  return (
    <>
      <section className="relative min-h-[80vh] md:h-[90vh] flex items-center overflow-hidden">
        <video
          src={waterproofing5}
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/65" />

        <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 py-24 md:py-32 text-center md:text-left">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 mb-5 bg-amber-600/20 border border-amber-500/40 rounded-full text-amber-300 text-xs sm:text-sm tracking-widest uppercase backdrop-blur-sm">
            <ShieldCheck size={14} />
            Trusted Waterproofing Experts
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-6xl font-serif font-extrabold text-white leading-tight tracking-wide">
            Luxury Waterproofing <br />
            <span className="bg-gradient-to-r from-amber-400 to-amber-600 bg-clip-text text-transparent">
              Solutions for Your Home
            </span>
          </h1>

          <p className="mt-4 sm:mt-6 text-base sm:text-lg text-gray-200 max-w-xl mx-auto md:mx-0">
            Protect your Terrace, Bathroom, Basement & Roof from leaks and dampness.  
            Long-lasting results backed with written warranty.
          </p>

          <div className="flex flex-wrap justify-center md:justify-start gap-3 sm:gap-4 mt-6 sm:mt-8 text-gray-200">
            {["Terrace Waterproofing", "Bathroom Leakage", "Basement Protection", "Crack Treatment"].map((item) => (
              <span key={item} className="flex items-center gap-2 bg-white/10 px-4 sm:px-5 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm backdrop-blur-sm border border-amber-500/30">
                <Droplets size={12} className="text-amber-400" />
                {item}
              </span>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row justify-center md:justify-start gap-4 sm:gap-6 mt-8 sm:mt-10">
            <button
              onClick={openModal}
              className="w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 bg-gradient-to-r from-amber-500 to-amber-700 text-white font-semibold tracking-wide rounded-full shadow-lg hover:scale-105 transition"
            >
              Get Free Inspection
            </button>

            <a href="https://wa.me/919876543210" target="_blank" rel="noreferrer" className="w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 bg-green-500 hover:bg-green-600 text-white font-semibold tracking-wide rounded-full shadow-lg hover:scale-105 transition text-center">
              WhatsApp Now
            </a>
          </div>
        </div>
      </section>

      {/* CHANGE: Yahan ab extra prop pass karne ki zaroorat nahi hai */}
      <BookConsultModal 
        isOpen={localIsConsultOpen} 
        onClose={handleClose} 
      />

      <section className="bg-[#f9f8f8] py-14 sm:py-20 text-center px-6">
        <h2 className="text-3xl sm:text-5xl font-serif text-black mb-3">Why Luxuriya Waterproofing?</h2>
        <p className="text-black/70 max-w-4xl mx-auto leading-relaxed text-sm sm:text-base">
          We provide long-lasting waterproofing solutions for homes, terraces,
          basements, and commercial buildings with guaranteed results. Our expert
          team uses advanced materials, modern application techniques, and proven
          systems to prevent leakage, dampness, and structural damage.
        </p>
      </section>
    </>
  );
};

export default HeroSection;